function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { extendSxProp } from '@mui/system/styleFunctionSx';
import useTheme from "../styles/useTheme.js";
import GlobalStyles from "../GlobalStyles/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
export { css, keyframes } from '@mui/system';
export { default as styled } from "../styles/styled.js";
export function globalCss(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        _jsx(GlobalStyles, {
            styles: typeof styles === 'function' ? function(theme) {
                return styles(_object_spread({
                    theme: theme
                }, props));
            } : styles
        }));
    };
}
// eslint-disable-next-line @typescript-eslint/naming-convention
export function internal_createExtendSxProp() {
    return extendSxProp;
}
export { useTheme };
